/* global Swiper */

/**
 * Global Posts Slider
 */
export class PostsSlider {

	/**
	 * Constructor
	 *
	 * @param {node} container
	 * @return {void}
	 */
	constructor( container ) {

		this.newsContainer = document.querySelector( container );
		if ( ! this.newsContainer ) {

			return false;

		}

		const blockSwiper = this.newsContainer.querySelector( '.c-posts-slider__swiper' );

		new Swiper( blockSwiper, {
			slidesPerView: 3,
			spaceBetween: 39,
			loop: true,
			slideClass: 'p-blog-loop-item',
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 0,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 24,
				},
				1100: {
					slidesPerView: 3,
					spaceBetween: 27,
				},
				1367: {
					slidesPerView: 3,
					spaceBetween: 39,
				},
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		} );

	}

}
